import React from "react";
import { useStaticQuery, graphql } from "gatsby";
/** @jsx jsx */
import { jsx, Box } from "theme-ui";
import { Flex, Heading, Text, Button } from "../core";
import { BackgroundVague } from "../svg";

const Contact = ({ colorVague = "background3", ...props }) => {
  const data = useStaticQuery(graphql`
    query ContactComponentQuery {
      markdownRemark(frontmatter: { componentKey: { eq: "contact-component" } }) {
        frontmatter {
          title
          subtitle
          buttonText
        }
      }
    }
  `);

  const { frontmatter } = data.markdownRemark;

  return (
    <Flex
      as="section"
      sx={{
        paddingTop: [15, 21, 31],
        paddingBottom: 9,
        backgroundColor: "primary",
        position: "relative",
        backgroundImage: "url(/img/bg-contact.svg)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      {...props}
    >
      <BackgroundVague
        width="100%"
        height={null}
        color={colorVague}
        sx={{ position: "absolute", top: "-1px" }}
      />
      <Box sx={{ textAlign: "center", px: [2, 2, 0] }}>
        <Heading as="h2" variant="h1" color="white" sx={{ marginBottom: 3 }}>
          {frontmatter.title}
        </Heading>
        <Text variant="h4" color="white" fontWeight="regular">
          {frontmatter.subtitle}
        </Text>
        <Button
          sx={{
            marginTop: 6,
            mx: "auto",
          }}
          to="/contact"
          backgroundColor="secondary"
        >
          {frontmatter.buttonText}
        </Button>
      </Box>
    </Flex>
  );
};

export default Contact; 